<template>
  <div class="orderlist">
    <h3>{{ getTitle() }}</h3>
    <p v-if="JSON.stringify(orders) === JSON.stringify({})">
      No se encontraron ordenes de lavado.
    </p>
    <OrderRow
      v-bind:order="order"
      v-bind:key="order.id"
      v-for="order in orders"
      v-bind:type="type"
      v-bind:mutable="isMutable()"
      v-bind:acceptText="acceptText"
      v-bind:rejectText="rejectText"
      v-bind:onRejectDialog="onRejectDialog"
      v-bind:onAcceptDialog="onAcceptDialog"
    />
  </div>
</template>

<script>
import OrderRow from "./OrderRow";

export default {
  name: "OrderList",
  components: {
    OrderRow
  },
  props: [
    "orders", "type", "mutable", "acceptText", "rejectText", "onAcceptDialog",
    "onRejectDialog"
  ],
  methods: {
    getTitle() {
      if (this.type == "TO_SEND") {
        return "Ordenes por enviar";
      }
      if (this.type == "TO_RECEIVE") {
        return "Ordenes por recoger";
      }
      if (this.type == "MY_ORDERS") {
        return "Mis Ordenes";
      }
      if (this.type == "OBSERVED") {
        return "Ordenes Observadas";
      }
    },
    isMutable() {
      return this.type != "MY_ORDERS"
    }
  },
  data: function() {
    return {
      types: ["TO_SEND", "TO_RECEIVE", "MY_ORDERS", "OBSERVED"],
    };
  }
};
</script>

<style scoped>
h3 {
  width: 100%;
  text-align: left;
  font-size: 25px;
}
</style>
